import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'summary',
  standalone: false,
})
export class SummaryPipe implements PipeTransform {
  transform(value: string): string {
    if (value === undefined || /^\s*$/.test(value)) {
      return '';
    }
    if (value.charAt(0) === "'") {
      value = value.substring(1);
    }
    if (value.charAt(value.length - 1) === "'") {
      value = value.substring(0, value.length - 1);
    }
    return value;
  }
}
